module.exports = __webpack_public_path__ + "static/motorcycleIcon-a658639a0eb8cc4c21b73b009360cfa9.png";